import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {RouterLink} from '@angular/router';
import {MenuProfileComponent} from '../../commons/menu-profile/menu-profile.component';
import {ButtonModule} from 'primeng/button';
import {ToolbarModule} from 'primeng/toolbar';
import {MenuModule} from 'primeng/menu';
import {Subject, takeUntil} from 'rxjs';
import {UserExternProps} from '@core/models/customer-extern';
import {UsuarioExternoService} from '@core/services/usuario-externo.service';
import {AuthService, Profile} from '@core/services/auth.service';

@Component({
    selector: 'app-toolbar',
    standalone: true,
    imports: [
        RouterLink,
        ToolbarModule,
        ButtonModule,
        MenuModule,
        MenuProfileComponent
    ],
    templateUrl: './toolbar.component.html',
    styleUrl: './toolbar.component.scss'
})
export class ToolbarComponent implements OnInit, OnDestroy {
    protected nomeUsuario?: string = '';
    protected readonly authService = inject(AuthService);
    private userExterno: UserExternProps | null = null;
    private profileClaimsGovbr: Profile | null = null;
    private readonly destroy$ = new Subject<void>();
    private readonly userService = inject(UsuarioExternoService);


    ngOnInit() {
        this.profileClaimsGovbr = this.authService.getProfileClaimsFromTokenGovbr();

        this.userService.usuario$
            .pipe(takeUntil(this.destroy$))
            .subscribe(user => {
                this.userExterno = user;
                this.nomeUsuario = this.authService.isAuthenticatedGovBr() ? this.profileClaimsGovbr?.name : this.userExterno?.nome;
            });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

}

